import { module as m } from 'modujs';
import gsap from 'gsap';
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(SplitText)

export default class extends m {
    constructor(m) {
        super(m);

        this.dom = {};
        this.dom.previous = null;
        this.dom.current = null;
        this.dom.images = gsap.utils.toArray('.background-image img');
        this.dom.previousImage = null;
        this.dom.currentImage = null;
        this.dom.path = gsap.utils.toArray('.background-image path').reverse();

        this.index = 0;
        this.indexImage = 0;
    }

    /**
     * INIT
     */
    init() {
        this.items = this.el.querySelectorAll('.title-item');
        new SplitText(this.items, {type: "chars", charsClass: "char char++"});

        this.dom.current = this.items[0];
        this.dom.currentImage = this.dom.images[0];

        const _tlStart = gsap.timeline({
            onComplete: () => {
                setTimeout(() => {
                    this.animateText()
                }, 1500)
            }
        });

        _tlStart.set(this.dom.current.querySelectorAll('.char'), {
            xPercent: -50,
            alpha: 0
        });
        _tlStart.set(this.dom.path, {
            transformOrigin: '0 50%',
            scale: 0.8,
            alpha: 0
        })
        _tlStart.to(this.dom.currentImage, {
            duration: 1,
            alpha: 1,
            ease: 'power4.out'
        }, 0)
        _tlStart.to(this.dom.path, {
            duration: 0.8,
            xPercent: 0,
            transformOrigin: '0 50%',
            scale: 1,
            alpha: 1,
            stagger: 0.04,
            ease: 'power4.out'
        }, 0)
        _tlStart.from(['.section-intro .title-container__left .icon-co', '.section-intro .baseline', '.section-intro .button'], {
            duration: 1,
            alpha: 0,
            y: 50,
            rotation: 0.01,
            stagger: 0.1,
            ease: 'power4.out'
        }, 0.1);
        _tlStart.from(['.section-intro .news-container'], {
            duration: 1,
            alpha: 0,
            y: 50,
            rotation: 0.01,
            ease: 'power4.out'
        }, 0.4);
        _tlStart.from('.section-intro .title-container__left .line', {
            duration: 1,
            scaleX: 0,
            transformOrigin: '0 0',
            ease: 'power4.inOut'
        }, 0.3);
        _tlStart.to(this.dom.current.querySelectorAll('.char'), {
            duration: 0.3,
            xPercent: 0,
            alpha: 1,
            stagger: 0.04,
            ease: 'power4.out'
        }, 0.4)
    }

    animateText() {

        if(this.dom.current)
            this.dom.previous = this.dom.current

        if(this.index < this.items.length - 1) {
            this.index++;
        }
        else {
            this.index = 0;

            if(this.indexImage < this.dom.images.length - 1)
                this.indexImage++
            else
                this.indexImage = 0;

            this.dom.previousImage = this.dom.currentImage;
            this.dom.currentImage = this.dom.images[this.indexImage];

            this.dom.previousImage.style.zIndex = "1";

            this.dom.currentImage.style.zIndex = "10";
            this.dom.currentImage.style.opacity = "0";

            const _tlImage = gsap.timeline({
                onComplete: () => {
                    this.dom.previousImage.style.opacity = "0";
                }
            });
            _tlImage.to(this.dom.path, {
                duration: 1,
                alpha: 0,
                ease: 'power4.out'
            }, 0)
            _tlImage.set(this.dom.path, {
                transformOrigin: '0 50%',
                scale: 0.8,
                alpha: 0
            })
            _tlImage.to(this.dom.path, {
                duration: 0.8,
                transformOrigin: '0 50%',
                scale: 1,
                alpha: 1,
                stagger: 0.04,
                ease: 'power4.out'
            })
            _tlImage.to(this.dom.currentImage, {
                duration: 1,
                alpha: 1,
                ease: 'power4.out'
            }, 0.6);
        }



        this.dom.current = this.items[this.index]
        const _tl = gsap.timeline({
            onComplete: () => {
                setTimeout(() => {
                    this.animateText()
                }, 1500)
            }
        });

        if(this.dom.previous) {
            _tl.to(this.dom.previous.querySelectorAll('.char'), {
                duration: 0.3,
                xPercent: 50,
                alpha: 0,
                stagger: 0.05,
                ease: 'power4.in'
            })
        }

        _tl.set(this.dom.current.querySelectorAll('.char'), {
            xPercent: -50,
            alpha: 0
        });
        _tl.to(this.dom.current.querySelectorAll('.char'), {
            duration: 0.3,
            xPercent: 0,
            alpha: 1,
            stagger: 0.05,
            ease: 'power4.out'
        })
    }

    /**
     * START
     */
    start() {}

    /**
     * DESTROY
     */
    destroy() {}
}
